import type { QueryClient } from '@tanstack/vue-query'
import type { Message } from '../model/message'
import type { MessagesQueryData } from '../model/messages-query-data'
import { areMessagesEqual } from './are-messages-equal'
import { getFreshMessagesQueryKey } from './fresh-messages-query'
import { getMessagesQueryKeyPrefixByChat } from './messages-query'

export function deleteMessage(queryClient: QueryClient, message: Message) {
  queryClient.setQueriesData(
    { queryKey: getFreshMessagesQueryKey(message.chatId) },
    (queryData: Message[] | undefined) => {
      if (!queryData) return

      return queryData.filter(existingMessage => !areMessagesEqual(existingMessage, message))
    }
  )

  queryClient.setQueriesData(
    { queryKey: getMessagesQueryKeyPrefixByChat(message.chatId) },
    (queryData: MessagesQueryData | undefined) => {
      if (!queryData) return

      const newPages = queryData.pages.map(page => ({
        ...page,
        data: page.data.filter(existingMessage => !areMessagesEqual(existingMessage, message)),
      }))

      return {
        ...queryData,
        pages: newPages,
      }
    }
  )
}
